module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/solution3_2@2x-7addc22553ccfd53e9c2b7d5180c017c.png";